export default "__VITE_ASSET__DMbk0f8U__"